import { FieldArray, useFormField } from '@calendly/form'
import { useInputId } from '@calendly/form/parts'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { recipientFieldsStatusSelector } from '../selectors'
import { ContactsContainer } from './components/contacts_container'
import { FieldWrapper, FieldLabel } from './field_parts'

export const BccField = () => {
  const id = useInputId()
  const [_, meta] = useFormField({ name: 'bcc' })
  const error = meta.touched && meta.error
  const { bcc: fieldsStatus } = useSelector(recipientFieldsStatusSelector)

  if (!fieldsStatus) return null

  return (
    <FieldWrapper
      invalid={Boolean(error)}
    >
      <FieldLabel htmlFor={id}>
        Bcc
        <span aria-hidden>:</span>
      </FieldLabel>
      <FieldArray
        name="bcc"
        render={(helpers) => (
          <ContactsContainer
            {...helpers}
            id={id}
            placeholderText={I18n.t('publisher.send_from_calendly.field_caption.placeholder')}
            fieldName="bcc"
            isSingleSelection={false}
            isDisabled={false}
          />
        )}
      />
    </FieldWrapper>
  )
}
